var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMultipleRecipientsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#FDF3E1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4727 7.99219V11.229L23.2361 17.0481L29.183 13.8872L23.2361 7.99219H13.4727Z",
    fill: "#00E3EE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2363 7.99219V17.0481L29.7635 20.9384H32.9998V7.99219H23.2363Z",
    fill: "#2EBDEE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2363 11.2305V14.4668L20 20.286L24.8819 16.6525L20 11.2305H10.2363Z",
    fill: "#EEF6FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20 11.2305V20.286L26.5269 24.1761H29.7637V11.2305H20Z",
    fill: "#DAEBFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7638 14.4648L14.1797 21.6996L16.764 27.411H26.5273V14.4648H16.7638Z",
    fill: "#FDBE00"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7 14.4648V27.411H11.4672L16.7635 31.0087V14.4648H7Z",
    fill: "#FFD82E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.45898 20.082V18.5586H16.7641L17.5597 19.3913L16.7641 20.082H9.45898Z",
    fill: "#FDBE00"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7637 18.5586H24.0688V20.082H16.7637V18.5586Z",
    fill: "#FD9D23"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M9.45898 23.3203H16.7641L17.5597 22.5584L16.7641 21.7969H9.45898V23.3203Z",
    fill: "#FDBE00"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7637 21.7969H24.0688V23.3203H16.7637V21.7969Z",
    fill: "#FD9D23"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultipleRecipientsIcon);
export default __webpack_public_path__ + "static/media/multiple_recipients_icon.4a239079.svg";
export { ForwardRef as ReactComponent };